import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import BandPop from '../Pop/BandPop/BandPop.vue';
import Ticket from '../Ticket/Ticket.vue';
export default {
  components: {
    Ticket: Ticket,
    BandPop: BandPop
  },
  data: function data() {
    return {
      formatList: [],
      bangParams: null
    };
  },
  methods: {
    // 数据分组
    groupList: function groupList() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth();
      var day = date.getDate();
      var ts = new Date(year, month, day).getTime(); // 当前是周几

      var week = date.getDay();
      week = week === 0 ? 7 : week; // 本周的开始与结束时间戳

      var start = ts - (week - 1) * 24 * 60 * 60 * 1000;
      var end = ts - (week - 8) * 24 * 60 * 60 * 1000; // 计算过去、现在和将来的场次

      var now = this.now;
      var list = this.setting.演出场次.map(function (v) {
        var status = '';
        var url = '';
        var cla = '';

        if (v.开始时间 < now && v.结束时间 > now) {
          status = '演出中';
          url = "txvideo://v.qq.com/TencentLiveActivity?pid=".concat(v.pid);
          cla = 'pink';
        } else if (v.结束时间 < now) {
          status = '看回放';
          url = "tenvideo2://?action=1&cover_id=".concat(v.cid);
          cla = 'orange';
        }

        return _objectSpread(_objectSpread({}, v), {}, {
          status: status,
          url: url,
          class: cla
        });
      });
      this.formatList = [{
        title: 'https://vfiles.gtimg.cn/vupload/20200903/ee90c31599216409671.png',
        list: list.filter(function (v) {
          return v.开始时间 >= start && v.结束时间 <= end;
        })
      }, {
        title: 'https://vfiles.gtimg.cn/vupload/20200829/4fa3ca1598682608608.png',
        list: list.filter(function (v) {
          return v.开始时间 > end;
        })
      }, {
        title: 'https://vfiles.gtimg.cn/vupload/20200829/8249481598682608611.png',
        list: list.filter(function (v) {
          return v.结束时间 < start;
        })
      }].filter(function (v) {
        return v.list.length > 0;
      });
    },
    // 分享
    share: function share(params) {
      this.eventBus.$emit('launchShare', {
        action: 'share',
        activity_name: params.activity_name
      });
    },
    // 设置支付面板信息并拉起支付
    setAndPay: function setAndPay(params) {
      this.$store.dispatch('setSelectPayInfo', params);
      this.openPay();
    }
  },
  mounted: function mounted() {
    this.groupList();
  }
};